import { useSelector } from 'react-redux'

import {
  customConversionsSelector,
  facebookClientAppsSelector,
  getFacebookClientAppsIsLoadingSelector
} from '../../../../../../modules/selectors/choices'

import { OUTCOME_APP_PROMOTION, OUTCOME_LEADS, OUTCOME_SALES } from '../../../../../../constants/campaigns'

import { partnerSelfAccountSelector } from '../../../../../../modules/selectors/selfAccounts'
import { OBJECTIVE } from '../../../../../Multiplatform/CampaignForms/fields'
import { objectivesList } from '../../../../../Multiplatform/CombinedFacebookTiktokCreate/CreateFormSelector/CampaignCreateForm/constants'

export const leadsOrSalesObjectives = [OUTCOME_LEADS, OUTCOME_SALES]

export const useHasMissingDatasetAndCustomConversion = () => {
  const customConversions = useSelector(customConversionsSelector)
  const partnerSelfAccount = useSelector(partnerSelfAccountSelector)

  return !customConversions.length && !partnerSelfAccount?.datasets?.length
}

export const useHasMissingClientApps = () => {
  const facebookClientApps = useSelector(facebookClientAppsSelector)
  const hasMissingClientApps = !facebookClientApps.length

  return hasMissingClientApps
}

export const useShowMissingDatasetAndCustomConversionWarning = values => {
  const hasMissingDatasetAndCustomConversion = useHasMissingDatasetAndCustomConversion()

  return hasMissingDatasetAndCustomConversion && leadsOrSalesObjectives.includes(values[OBJECTIVE])
}

export const useShowMissingClientAppsWarning = values => {
  const hasMissingClientApps = useHasMissingClientApps()

  return hasMissingClientApps && values[OBJECTIVE] === OUTCOME_APP_PROMOTION
}

export const useObjectivesListIsLoading = () => {
  // don't use wasLoaded and error here, because there could be the case when the getFacebookClientApps is not starting to be fetch but the loading was true
  const getFacebookClientAppsIsLoading = useSelector(getFacebookClientAppsIsLoadingSelector)
  return getFacebookClientAppsIsLoading
}

export const useFormattedObjectivesList = () => {
  const hasMissingDatasetAndCustomConversion = useHasMissingDatasetAndCustomConversion()
  const hasMissingClientApps = useHasMissingClientApps()

  return objectivesList.map(item => {
    const value = item.value
    const shouldGreyOutOption =
      (hasMissingDatasetAndCustomConversion && (value === OUTCOME_SALES || value === OUTCOME_LEADS)) ||
      (hasMissingClientApps && value === OUTCOME_APP_PROMOTION)

    return {
      ...item,
      ...(shouldGreyOutOption
        ? {
            pseudoDisabled: true
          }
        : {})
    }
  })
}
